angular.module('EdxManageAdminModule', [
  'EdxCommonModule',
  'EdxManageCommonModule'
]);
